/**
 * Extracts the path and file extension from a Cloudinary URL containing 'auto/'.
 *
 * @param imageUrl - The URL string to extract information from.
 * @returns An object containing:
 *   - `path`: The portion of the URL path after 'auto/' and before the first dot (.).
 *   - `extension`: The file extension from the URL.
 */
export function getImagePathAndExtension(imageUrl: string) {
  try {
    const { pathname } = new URL(imageUrl);
    const match =
      pathname.match(/auto\/(.*)\./) ||
      pathname.match(/upload\/(.*)\./) ||
      pathname.match(/fetch\/(.*)\./);
    const path = match ? match[1] : '';
    const extension = pathname.split('.')[1];

    return {
      path: path.includes('%') ? decodeURIComponent(path) : path,
      extension,
    };
  } catch (error) {
    return { path: '', extension: '' };
  }
}
